<template>
  <div class="bg-white">
  <div class="chat-container w-100  bg-white  hide-scroll overflow-scroll" style="height: 122%">
    <div class="bg-green" style="height: 150px;">
      <div class="w-100">
        <div class="row w-100">
          <router-link :to="'/'+getMerchant().code+'/ticket/order-history'">
            <div class="col-1">
              <div class="nav-back" style="top: 15px!important;margin-left: 10px!important">
                <img src="../../assets/img/icon/back-white.png" width="20">
              </div>
            </div>
          </router-link>
          <div class="col-9 py-14px">
            <p class="text-white heading-6 mb-0 text-truncate">{{$t('merchant.ticket-detail')}}</p>
          </div>
        </div>
      </div>
    </div>

    <loader v-if="ticket_detail.loader" />
    <div class="container bg-white w-100 pb-3" v-else style="top: 45px;">
      <div class="position-relative" style="top: -100px">
        <div class="bg-green rounded-50 p-4 mx-auto position-relative bullet"></div>
        <div class="bg-white rounded-10 position-relative" style="margin-top: -10px;">
          <div class="box-shadow-bold rounded-10 mb-4">
            <div class="bg-white py-4 px-3 rounded-10">
              <div class="row slim-grid-row">
                <div class="col-6">
                  <p class="mb-0 body-3-3-2  text-light-bold">{{$t('merchant.ticket-code')}}</p>
                  <p class="mb-0 body-3-3-2">{{ticket_detail.data.ticket_code}}</p>
                </div>
                <div class="col-6 text-right">
                  <p class="mb-0 body-3-3-2 text-light-bold">{{$t('merchant.visit-date')}}</p>
                  <p class="mb-0 body-3-3-2">{{formatDate(ticket_detail.data.visit_date)}}</p>
                </div>
              </div>
              <div class="row slim-grid-row mt-3 mb-2 pb-2">
                <div class="col-12">
                  <p class="mb-0 text-center d-block body-2-4 text-green" v-if="ticket_detail.data.status == 'COMPLETE'">{{$t('general.success')}}</p>
                  <p class="mb-0 text-center d-block body-2-4 text-danger" v-else-if="ticket_detail.data.status == 'CANCELLED'">{{$t('general.cancelled')}}</p>
                  <p class="mb-0 text-center d-block body-2-4 text-info" v-else-if="ticket_detail.data.status == 'WAITING_PAYMENT_CONFIRMATION'">{{$t('general.pending')}}</p>
                  <div class="w-100 text-center py-3" v-if="ticket_detail.data.status == 'WAITING_PAYMENT_CONFIRMATION' && ticket_detail.data.payment_details.payment_method != 'CREDIT_CARD'">
                    <button class="btn bg-orange px-3 py-2 text-white body-2" @click="goPaymentForm()">{{$t('general.process-payment')}}</button>
                  </div>
                  <img :src="ticket_detail.data.url" class="w-100" />
                  <div class="w-100 text-center px-4">
                    <p class="mt-3 mb-1 body-2-4" style="color: #414955">{{ticket_detail.data.merchant.name}} {{$t('general.ticket')}}</p>
                    <p class="mb-0 body-3-3 text-light-bold d-inline-block position-relative align-top">{{ticket_detail.data.merchant.address}}</p>
                  </div>
                  <!-- Swipe to Claim -->
                  <div class="w-100 mt-4 pt-4 border-2-top-dashed" v-if="getMerchant().redeem_type == 'MANUAL'">
                    <div class="w-100 p-3 bg-green-light-2 radius-6" v-if="redeem.claimed">
                      <p class="mb-0 body-1-4 text-center">
                        This ticket has been claimed
                      </p>
                    </div>
                    <template v-else>
                      <p class="body-2-4 text-danger mb-3 text-center" v-if="redeem.error != ''">{{ redeem.error }}</p>
                      <slide-unlock
                        ref="vueslideunlock"
                        :auto-width="true"
                        :circle="true"
                        :disabled="false"
                        :noanimate="false"
                        :width="400"
                        :height="60"
                        text="Slide to redeem"
                        :success-text="redeem.claimed ? 'Claimed' : 'Please Wait..'"
                        @completed="toggleRedeemWarning()"
                        />
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <p class="mb-2 body-2-4 text-light-bold">{{$t('merchant.visitor-detail')}}</p> -->
          <div class="box-shadow-bold rounded-10 mb-4 p-3 bg-white">
            <div class="pb-3 border-bottom-dashed">
            <p class="mb-1 sub-heading-1-1 color-black">{{ticket_detail.data.visitor_details.gender}}. {{ticket_detail.data.visitor_details.first_name}} {{ticket_detail.data.visitor_details.last_name}}</p>
            <p class="mb-0 body-2-2 text-light-bold">{{ticket_detail.data.visitor_details.email}}</p>
            </div>
            <div class="pt-3 row no-gutters">
              <div class="col-5">
                 <p class="mb-0 body-2-2">{{$t('general.payment-method')}}</p>
              </div>
              <div class="col-7 text-right">
                <p class="mb-0 body-2-4">{{convertPaymentMethod(ticket_detail.data.payment_details.payment_channel,ticket_detail.data.payment_details.payment_method)}}</p>
              </div>
            </div>
          </div>
          <div class="box-shadow-bold rounded-10">
            <div class="border-bottom p-3">
              <!-- <p class="mb-2 body-2-4 text-light-bold">{{$t('merchant.ticket-detail')}}</p> -->
              <div class="row no-gutters align-items-end" v-for="(ticket,index) in ticket_detail.data.ticket_details" :class="{'border-bottom-dashed mb-2 pb-2': (index+1) != ticket_detail.data.ticket_details.length}">
                <div class="col-8">
                  <div class="ml-1">
                    <p class="mb-0 body-2-4 d-inline-block align-middle mr-1">{{ticket.qty}}X {{ticket.variant_name}}</p><p class="mb-0 body-2-2 d-inline-block align-middle">{{ticket.name}}</p>
                  </div>
                </div>
                <div class="col-4 text-right">
                  <p class="mb-0 body-2-2 my-1">{{formatCurrency(ticket.price_sell_discount)}}</p>
                </div>
              </div>
            </div>
            <div class="row p-3">
              <div class="col-5" >
                <p class="mb-0 body-1 color-black">Total</p>
              </div>
              <div class="col-7">
                <p class="mb-0 sub-heading-1-2 color-black text-right">{{formatCurrency(ticket_detail.data.total_payment)}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="!isNotLogin() && ticket_detail.data.status === 'COMPLETE'">
        <button class="btn bg-green w-100 py-3 text-white body-2" v-if="ticket_detail.data.feedback.length == 0" style="margin-top: -100px" @click="goFeedbackForm()">{{$t('general.give-a-feedback')}}</button>
        <div class="position-relative" v-else style="top: -70px">
          <p class="mt-4 mb-3 px-2 color-black body-2">Feedback</p>
          <div class="p-3 mt-3 box-shadow-bold rounded-10">
            <div class="border-bottom">
              <div class="d-block">
                <p class="mb-0 body-1 text-color-dark">{{ticket_detail.data.customer_details.first_name}} {{ticket_detail.data.customer_details.last_name}}</p>
                <p class="mb-0 body-3">{{formatDate(ticket_detail.data.feedback[0].created_at)}}</p>
                <star-rating 
                  class="mt-1-"
                  :star-size="12"
                  active-color="#fbc632"
                  border-color="#fff" 
                  :increment="1"
                  :rating="ticket_detail.data.feedback[0].star"
                  :read-only="true"
                  :show-rating="false"
                  :rounded-corners="true"
                  :border-width="1"
                  :padding="2">    
                </star-rating>
              </div>
              <template v-if="ticket_detail.data.feedback[0].image.length > 0">
                <div class="row slim-grid-row my-2" v-if="ticket_detail.data.feedback[0].image.length < 3">
                  <div :class="{'col-12': ticket_detail.data.feedback[0].image.length == 1, 'col-6' : ticket_detail.data.feedback[0].image.length == 2}" v-for="feed_img in ticket_detail.data.feedback[0].image">
                    <img :src="feed_img.image_url" class="object-fit rounded w-100" height="200">
                  </div>
                </div>
                <div class="w-100 mt-2 mb-4" v-else>
                  <flickity ref="flickity" :options="flickityOptions">
                    <div class="carousel-cell w-100" v-for="feed_img in ticket_detail.data.feedback[0].image">
                      <div class="w-100" style="height:200px !important;">
                        <img :src="feed_img.image_url" class="img-fit rounded">
                      </div>
                    </div>
                  </flickity>
                </div>
              </template>
              <p class="body-2-2 pt-2 font-regular">{{ticket_detail.data.feedback[0].message}}</p>
              <div class="bg-light mt-2 mb-3 py-2 px-3 rounded" v-if="ticket_detail.data.feedback.length > 1">
                <div class="d-inline-block">
                  <p class="mb-0 body-1 text-color-dark text-14 mt-1">{{ticket_detail.data.merchant.name}} <img src="../../assets/img/icon/success.png" width="12" class="d-inline-block"></p>
                  <p class="mb-0 body-3">{{formatDate(ticket_detail.data.feedback[1].created_at)}}</p>
                </div>
                <p class="body-2-2 pt-2 font-regular">{{ticket_detail.data.feedback[1].message}}</p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    
    <b-modal ref="warning_redeem" no-close-on-esc no-close-on-backdrop hide-header>
      <div class="py-5 px-4 text-center">
        <div class="mb-4">
          <svg width="140" height="128" viewBox="0 0 140 128" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.2347 126.908H121.765C133.12 126.908 140 119.027 140 108.807C140 105.668 139.065 102.395 137.395 99.456L85.5629 9.15077C82.0894 3.07252 76.1452 0 69.9997 0C63.8548 0 57.8433 3.07252 54.437 9.15077L2.60496 99.456C0.801527 102.462 0 105.668 0 108.807C0 119.027 6.87976 126.908 18.2347 126.908Z" fill="#EEB815"/>
            <path d="M70.067 82.2901C66.5936 82.2901 64.6568 80.286 64.5895 76.7459L63.7214 40.4103C63.6548 36.8702 66.2595 34.3321 69.9997 34.3321C73.6071 34.3321 76.4119 36.937 76.3452 40.4771L75.3438 76.7459C75.2765 80.3533 73.3398 82.2901 70.067 82.2901ZM70.067 104.666C66.0589 104.666 62.5861 101.46 62.5861 97.5192C62.5861 93.5112 65.9922 90.3056 70.067 90.3056C74.0745 90.3056 77.4812 93.4445 77.4812 97.5192C77.4812 101.527 74.0078 104.666 70.067 104.666Z" fill="white"/>
          </svg>
        </div>

        <p class="mb-0 body-2-2 text-30 text-warning font-bold">Warning</p>
        <p class="mb-0 body-1-2 w-75 mx-auto">Make sure you are in front of the <b>{{ getMerchant().name }}</b> staff when redeeming your ticket</p>
      </div>
      <template slot="modal-footer">
        <div class="w-100">
          <div class="row slim-grid-row">
            <div class="col-5">
              <button class="g-btn g-btn-lg g-btn-dark w-100" @click="cancelRedeem">Cancel</button>
            </div>
            <div class="col-7">
              <state-button variant="primary" block size="lg" :click="redeemTicket">Continue Redeem</state-button>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</div>
</template>
<script>
  import {get,post} from '@/services/index.js';
  import {formatCurrency,formatDate,checkDataExist} from '@/utils/index.js'
  import Flickity from 'vue-flickity';
  import {mapGetters} from 'vuex';
  import SlideUnlock from "vue2-slide-unlock"

  export default{
    components:{
      Flickity,
      SlideUnlock
    },
    data(){
      return{
        ticket_detail:{
          data: {},
          loader: true
        },
        flickityOptions: {
          initialIndex: 0,
          prevNextButtons: false,
          pageDots: true,
          wrapAround: true,
          adaptiveHeight: true,
        },
        redeem:{
          load: false,
          error: '',
          claimed: false
        },
      }
    },
    mounted(){
      this.loadTicketDetail()
    },
    methods:{
      ...mapGetters(['getMerchant','isNotLogin']),
      formatCurrency(value){
        return formatCurrency(value);
      },
      formatDate(date){
        return formatDate(date);
      },
      loadTicketDetail(){
        this.ticket_detail.loader = true
        get("CORE","tx-ticket-detail/"+this.$route.params.tx_order_id).then(response=>{
          let res = response.data;
          if (res.success) {
            this.ticket_detail.data = res.data
            if(this.getMerchant().redeem_type == 'MANUAL'){
              this.redeem.claimed = res.data.tx_order_adapter.some(x=>x.status == 'CLAIMED')
            }
          }
          this.ticket_detail.loader = false
        })
      },
      goFeedbackForm(){
        this.$router.push({
          path: '/'+this.getMerchant().code+'/feedback/'+this.$route.params.tx_order_id
        })
      },
      goPaymentForm(){
        this.$router.push({
          path: '/'+this.getMerchant().code+'/payment/'+this.$route.params.tx_order_id
        })
      },
      convertPaymentMethod(channel,method){
        if(checkDataExist(channel)){
          if(channel == 'VA_ATM_BERSAMA'){
            return 'BANK TRANSFER'
          }else if(channel == 'VA_BPD_BALI'){
            return 'BPD Bali'
          }else if(channel == 'CREDIT_CARD'){
            return 'CREDIT CARD'
          }else{
            return channel 
          }
        }else{
          if(method == 'VIRTUAL_ACCOUNT'){
            return 'BANK TRANSFER'
          }else if(method == 'CREDIT_CARD'){
            return 'CREDIT CARD'
          }else{
            return method 
          }
        }
      },
      redeemTicket(){
        return new Promise((success,fail)=>{
          this.redeem.load = true
          this.redeem.error = ''
          
          post("CORE","claim-ticket-manual",{
            merchant_id: this.getMerchant().id,
            e_ticket_id: this.ticket_detail.data.ticket_code
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.redeem.load = false
              this.redeem.claimed = true
              this.toggleRedeemWarning()
              success()
            }else{
              this.redeem.load = false
              this.redeem.error = res.message
              this.cancelRedeem()
              fail()
            }
          })
        })
      },
      toggleRedeemWarning(){
        this.$refs.warning_redeem.toggle()
      },
      cancelRedeem(){
        this.$refs.warning_redeem.hide()
        this.$refs.vueslideunlock.reset()
      }
    }
  }
</script>
<style scoped>
  .mt-1-{
    margin-top: -4px !important;
  }
  input {
    border: none;
    border-radius: 0px !important;
    border-bottom: 1px solid #0000001A;
  }
  .bullet{
    width: 50px;
    height: 50px;
    z-index: 99
  }

  .text-light-bold{
    color: #414955A6!important
  }
  .w-90{
    width: 90%;
  }
  .break {
    height: 15px
  }
  .dot-green{
    height: 5px;
    width: 5px;
    border-radius: 50%;
    background: #79a33a !important;
  }
  .color-black {
    color: #000;
  }

  .bg-smoth-light {
    background-color: #FAFAFC;
  }

  .rounded-top-10 {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .border-bottom-dashed{
    border-bottom: 1px dashed #dee2e6;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ticket/TicketOrderHistoryDetail.vue